import logger from '../utils/rbmc.logger';
import urlUtils from '../utils/rbmc.url-utils';
import pdpFlockingWFL from '../pdp/rbmc.wfl-flocking';

const notifyMe = {
    notifyMePanel:      undefined,
    configurationArea:  undefined,
    successBox:         undefined,
    successTimeout:     undefined,
    notifyMeEmailInput: undefined,
    init() {
        notifyMe.notifyMePanel      = $('.pdp__notify-me');
        notifyMe.configurationArea  = $('#pdp__configuration-area');
        notifyMe.successBox         = $('.pdp__notify-success-box');
        notifyMe.notifyMeEmailInput = $('#pdp__notify-me-email');
    },

    bindEvents() {
        let $body = $('body');
        $body.on('click', '#pdp__notify-me-trigger', notifyMe.showNotifyMePanel);
        $('#pdp__notify-me-form').on('submit', notifyMe.createNotifyMeRequest);
        $('.pdp__notify-close').on('click', notifyMe.hideNotifyMePanel);
        $('.pdp__notify-success-close').on('click', notifyMe.closeSuccessNotifyMessage);
    },

    showNotifyMePanel(event) {
        event.preventDefault();
        notifyMe.configurationArea.addClass('d-none');
        pdpFlockingWFL.wflFlockFormWrapper.addClass('d-none');
        notifyMe.notifyMePanel.removeClass('d-none');
    },

    hideNotifyMePanel() {
        notifyMe.notifyMePanel.addClass('d-none');
        notifyMe.configurationArea.removeClass('d-none');
        pdpFlockingWFL.wflFlockFormWrapper.removeClass('d-none');
    },

    createNotifyMeRequest(event) {
        const $this = $(this);
        event.preventDefault();
        let productCode = $('#productCode').val();
        if (notifyMe.notifyMeEmailInput.val() !== '') {
            $.ajax({
                url:    `${urlUtils.getBaseUrl()}p/${productCode}/notify/`,
                method: 'POST',
                data:   $this.serialize()
            }).done(function (response) {
                if (response.trim() === 'SUCCESS') {
                    notifyMe.showSuccessNotifyMessage();
                } else {
                    notifyMe.notifyMeEmailInput.parent().addClass('custom-form--invalid');
                    notifyMe.notifyMeEmailInput.focus();
                }
            }).fail(function () {
                logger.log('Failed to request notify me action');
            });
        } else {
            notifyMe.notifyMeEmailInput.focus();
        }
    },

    createNotifyMeRequestArchibald(productCode, form) {
        const url = `${urlUtils.getBaseUrl()}p/${productCode}/notify/`;

        return $.ajax({
            url:    url,
            method: 'POST',
            data:   $(form).serialize()
        });
    },

    showSuccessNotifyMessage() {
        notifyMe.notifyMePanel.addClass('d-none');
        notifyMe.notifyMeEmailInput.val('');
        notifyMe.successBox.removeClass('d-none');
        notifyMe.successTimeout = setTimeout(function () {
            notifyMe.closeSuccessNotifyMessage()
        }, 5000);
    },

    closeSuccessNotifyMessage() {
        clearTimeout(notifyMe.successTimeout);
        notifyMe.successBox.addClass('d-none');
        notifyMe.configurationArea.removeClass('d-none');
    }
};

export default notifyMe;
